// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Center the content */
.not-found-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f4f4f4;
    color: #333;
    text-align: center;
    font-family: Arial, sans-serif;
  }
  
  /* Styling for the error code */
  .error-code {
    font-size: 8rem;
    font-weight: bold;
    color: #ff6b6b;
  }
  
  /* Styling for the error message */
  .error-message {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }
  
  /* Styling for the home link */
  .home-link {
    display: inline-block;
    margin-top: 20px;
    padding: 10px 20px;
    font-size: 1rem;
    color: white !important;
    background-color: #333;
    text-decoration: none;
    border-radius: 5px;
    transition: background-color 0.3s ease;
  }
  
  .home-link:hover {
    background-color: #ff6b6b;
  }
  `, "",{"version":3,"sources":["webpack://./src/app/pages/error-page/error-page.component.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA,+BAA+B;EAC/B;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA,kCAAkC;EAClC;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA,8BAA8B;EAC9B;IACE,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":["/* Center the content */\n.not-found-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background-color: #f4f4f4;\n    color: #333;\n    text-align: center;\n    font-family: Arial, sans-serif;\n  }\n  \n  /* Styling for the error code */\n  .error-code {\n    font-size: 8rem;\n    font-weight: bold;\n    color: #ff6b6b;\n  }\n  \n  /* Styling for the error message */\n  .error-message {\n    font-size: 1.5rem;\n    margin-bottom: 20px;\n  }\n  \n  /* Styling for the home link */\n  .home-link {\n    display: inline-block;\n    margin-top: 20px;\n    padding: 10px 20px;\n    font-size: 1rem;\n    color: white !important;\n    background-color: #333;\n    text-decoration: none;\n    border-radius: 5px;\n    transition: background-color 0.3s ease;\n  }\n  \n  .home-link:hover {\n    background-color: #ff6b6b;\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
